<app-nav-bar/>
<div class="container col-xxl-8 px-4 py-2" *ngIf="dataEspecialidad">
  <div class="row flex-lg-row-reverse align-items-center g-5 py-5">
    <div class="col-10 col-sm-8 col-lg-6">
      <img src="{{serverImgenUrl}}{{dataEspecialidad.imagen}}" class=" rounded mx-lg-auto img-fluid" alt="{{ dataEspecialidad.categoria}}" width="500" height="500" loading="lazy">

    </div>
    <div class="col-lg-6">
      <img src="{{serverImgenUrl}}{{dataEspecialidad.icono}}" class=" rounded mx-lg-auto img-fluid" alt="{{ dataEspecialidad.categoria}}icono" width="50" height="50" loading="lazy">
      <h1 class="display-5 fw-bold lh-1 mb-3">{{ dataEspecialidad.categoria}}</h1>
      <p class="lead text-secondary">{{ dataEspecialidad.descripcion}}</p>
      <div class="d-grid gap-2  d-md-flex justify-content-md-start">
      </div>
    </div>
  </div>
</div>

<app-sucursales-especialidades [sucursales]="dataEspecialidad.centrosMedicos" />
<app-promociones-especialidades [categoria]="dataEspecialidad.categoria"/>
<app-procedimientos-especialidades [procedimientos]="dataEspecialidad.procedimientosList"/>

<app-footer-persona/>
